var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComponent22(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3999 12.0996H28.5999C29.6999 12.0996 30.5999 12.9996 30.5999 14.0996V16.2996C30.5999 17.0996 30.0999 18.0996 29.5999 18.5996L25.2999 22.3996C24.6999 22.8996 24.2999 23.8996 24.2999 24.6996V28.9996C24.2999 29.5996 23.8999 30.3996 23.3999 30.6996L21.9999 31.5996C20.6999 32.3996 18.8999 31.4996 18.8999 29.8996V24.5996C18.8999 23.8996 18.4999 22.9996 18.0999 22.4996L14.2999 18.4996C13.7999 17.9996 13.3999 17.0996 13.3999 16.4996V14.1996C13.3999 12.9996 14.2999 12.0996 15.3999 12.0996Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.93 12.0996L16 19.9996",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComponent22);
export default __webpack_public_path__ + "static/media/Component 22.f054a7ccb2674457800cbf1445641bdd.svg";
export { ForwardRef as ReactComponent };